import type { IconData } from '@stacksjs/iconify-core'

export const arrowUpLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2.757 3.828v5.586a1 1 0 0 1-2 0v-8a.997.997 0 0 1 1-1h8a1 1 0 1 1 0 2H4.172l6.778 6.778a1 1 0 1 1-1.414 1.415z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowUpLeft
